export default __webpack_public_path__ + "static/about-us-9eeb06d108e651404fa46527d317a9c9.webp";